/**
 * Eddie Borgo — Collection Filter Bar
 * AJAX filtering via Shopify Section Rendering API
 * Search, filter dropdowns, sort, active pills, mobile drawer
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 300;
  var SECTION_ID = null;
  var COLLECTION_URL = '';
  var container = null;
  var productGrid = null;
  var paginationEl = null;
  var searchInput = null;
  var searchClear = null;
  var sortSelect = null;
  var countEl = null;
  var debounceTimer = null;
  var previousSort = '';

  function init() {
    container = document.querySelector('[data-eb-filters]');
    if (!container) return;

    COLLECTION_URL = container.getAttribute('data-collection-url') || '';

    // Find the section wrapper to get section ID
    var sectionWrapper = container.closest('[data-section-id]');
    SECTION_ID = sectionWrapper ? sectionWrapper.getAttribute('data-section-id') : null;

    productGrid = document.querySelector('.product-list');
    paginationEl = document.querySelector('.pagination, .paginate');
    searchInput = container.querySelector('[data-eb-filter-search]');
    searchClear = container.querySelector('[data-eb-filter-search-clear]');
    sortSelect = container.querySelector('[data-eb-filter-sort]');
    countEl = container.querySelector('[data-eb-filter-count]');

    if (sortSelect) {
      previousSort = sortSelect.value;
    }

    bindDropdowns();
    bindSearch();
    bindSort();
    bindCheckboxes();
    bindPriceInputs();
    bindActivePills();
    bindMobile();
    bindOutsideClick();
  }

  /* --- Dropdown Toggle --- */
  function bindDropdowns() {
    var buttons = container.querySelectorAll('[data-eb-filter-toggle]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var paramName = btn.getAttribute('data-eb-filter-toggle');
        var dropdown = container.querySelector('[data-eb-filter-dropdown="' + paramName + '"]');
        var isOpen = dropdown && dropdown.classList.contains('is-open');

        // Close all dropdowns first
        closeAllDropdowns();

        if (!isOpen && dropdown) {
          dropdown.classList.add('is-open');
          btn.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function closeAllDropdowns() {
    var dropdowns = container.querySelectorAll('.eb-filters__dropdown');
    var buttons = container.querySelectorAll('.eb-filters__btn');
    dropdowns.forEach(function (d) { d.classList.remove('is-open'); });
    buttons.forEach(function (b) {
      b.classList.remove('is-open');
      b.setAttribute('aria-expanded', 'false');
    });
  }

  function bindOutsideClick() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.eb-filters__btn-wrap')) {
        closeAllDropdowns();
      }
    });
  }

  /* --- Search (client-side filtering by product title) --- */
  function bindSearch() {
    if (!searchInput) return;

    function handleSearchInput() {
      var val = searchInput.value.trim();
      searchClear.classList.toggle('is-visible', val.length > 0);

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        filterProductsBySearch(val);
      }, DEBOUNCE_MS);
    }

    searchInput.addEventListener('input', handleSearchInput);
    searchInput.addEventListener('change', handleSearchInput);
    searchInput.addEventListener('paste', function () {
      /* Paste event fires before the value updates — defer to next tick */
      setTimeout(handleSearchInput, 0);
    });

    searchClear.addEventListener('click', function () {
      searchInput.value = '';
      searchClear.classList.remove('is-visible');
      filterProductsBySearch('');
    });
  }

  function filterProductsBySearch(query) {
    var grid = document.querySelector('.product-list');
    if (!grid) return;

    /* Read search-field settings from data attributes */
    var searchTitle = container.getAttribute('data-search-title') !== 'false';
    var searchVendor = container.getAttribute('data-search-vendor') !== 'false';
    var searchType = container.getAttribute('data-search-type') === 'true';
    var searchTags = container.getAttribute('data-search-tags') === 'true';

    var items = grid.querySelectorAll('.product');
    var visibleCount = 0;
    var lowerQuery = query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    items.forEach(function (item) {
      if (!query) {
        item.classList.remove('eb-search-hidden');
        visibleCount++;
        return;
      }

      var haystack = '';

      /* Product title */
      if (searchTitle) {
        var titleEl = item.querySelector('.product-card-details__title, .product-title, h3, h2');
        if (titleEl) haystack += ' ' + titleEl.textContent;
      }

      /* Vendor */
      if (searchVendor) {
        var vendorEl = item.querySelector('.product-card-details__vendor, .brand');
        if (vendorEl) haystack += ' ' + vendorEl.textContent;
      }

      /* Product type (from data attribute) */
      if (searchType) {
        var productType = item.getAttribute('data-product-type');
        if (productType) haystack += ' ' + productType;
      }

      /* Tags (from data attribute) */
      if (searchTags) {
        var productTags = item.getAttribute('data-product-tags');
        if (productTags) haystack += ' ' + productTags.replace(/,/g, ' ');
      }

      haystack = haystack.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      if (haystack.indexOf(lowerQuery) !== -1) {
        item.classList.remove('eb-search-hidden');
        visibleCount++;
      } else {
        item.classList.add('eb-search-hidden');
      }
    });

    // Update count
    if (countEl) {
      countEl.textContent = visibleCount + ' PRODUCTS';
    }
  }

  /* --- Sort --- */
  function bindSort() {
    if (!sortSelect) return;
    sortSelect.addEventListener('change', function () {
      var searchVal = searchInput ? searchInput.value.trim() : '';
      if (searchVal.length === 0) {
        previousSort = sortSelect.value;
      }
      applyFilters();
    });
  }

  /* --- Checkbox Filters --- */
  function bindCheckboxes() {
    container.addEventListener('change', function (e) {
      if (e.target.matches('[data-eb-filter-value]')) {
        applyFilters();
      }
    });
  }

  /* --- Price Range Slider --- */
  function bindPriceInputs() {
    var sliders = container.querySelectorAll('[data-eb-price-slider]');
    sliders.forEach(function (wrapper) {
      var sliderMin = wrapper.querySelector('[data-eb-slider-min]');
      var sliderMax = wrapper.querySelector('[data-eb-slider-max]');
      var inputMin = wrapper.querySelector('[data-eb-price-min]');
      var inputMax = wrapper.querySelector('[data-eb-price-max]');
      var range = wrapper.querySelector('[data-eb-slider-range]');
      var rangeMinVal = parseFloat(wrapper.dataset.rangeMin) || 0;
      var rangeMaxVal = parseFloat(wrapper.dataset.rangeMax) || 1000;

      if (!sliderMin || !sliderMax) return;

      function updateRange() {
        var minVal = parseFloat(sliderMin.value);
        var maxVal = parseFloat(sliderMax.value);
        var total = rangeMaxVal - rangeMinVal;
        if (total <= 0) return;
        var leftPct = ((minVal - rangeMinVal) / total) * 100;
        var rightPct = ((rangeMaxVal - maxVal) / total) * 100;
        if (range) {
          range.style.left = leftPct + '%';
          range.style.right = rightPct + '%';
        }
      }

      sliderMin.addEventListener('input', function () {
        var minVal = parseFloat(sliderMin.value);
        var maxVal = parseFloat(sliderMax.value);
        if (minVal > maxVal) {
          sliderMin.value = maxVal;
        }
        if (inputMin) inputMin.value = sliderMin.value;
        updateRange();
      });

      sliderMax.addEventListener('input', function () {
        var minVal = parseFloat(sliderMin.value);
        var maxVal = parseFloat(sliderMax.value);
        if (maxVal < minVal) {
          sliderMax.value = minVal;
        }
        if (inputMax) inputMax.value = sliderMax.value;
        updateRange();
      });

      // Sync number inputs to sliders (visual only, no navigation)
      if (inputMin) {
        inputMin.addEventListener('input', function () {
          sliderMin.value = inputMin.value;
          updateRange();
        });
      }
      if (inputMax) {
        inputMax.addEventListener('input', function () {
          sliderMax.value = inputMax.value;
          updateRange();
        });
      }

      // Apply button triggers navigation
      var applyBtn = wrapper.querySelector('[data-eb-price-apply]');
      if (applyBtn) {
        applyBtn.addEventListener('click', function () {
          applyFilters();
        });
      }

      // Initial range position
      updateRange();
    });
  }

  /* --- Active Filter Pills --- */
  function bindActivePills() {
    // Pills and clear all are regular <a> links — they navigate naturally
    // No JS override needed
  }

  /* --- Mobile Drawer --- */
  function bindMobile() {
    var toggleBtn = container.querySelector('[data-eb-mobile-filter-toggle]');
    var drawer = container.querySelector('[data-eb-mobile-drawer]');
    var closeBtn = container.querySelector('[data-eb-mobile-close]');
    var applyBtn = container.querySelector('[data-eb-mobile-apply]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-animating');
      document.body.style.overflow = 'hidden';
      // Force reflow so browser registers the display change before animating
      drawer.offsetHeight;
      drawer.classList.add('is-open');
    }

    function closeDrawer(callback) {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      // Wait for transition to finish before hiding
      var onEnd = function () {
        drawer.removeEventListener('transitionend', onEnd);
        drawer.classList.remove('is-animating');
        if (callback) callback();
      };
      drawer.addEventListener('transitionend', onEnd);
      // Fallback if transitionend doesn't fire
      setTimeout(function () {
        drawer.classList.remove('is-animating');
        if (callback) callback();
      }, 400);
    }

    if (toggleBtn && drawer) {
      toggleBtn.addEventListener('click', openDrawer);
    }

    if (closeBtn && drawer) {
      closeBtn.addEventListener('click', function () { closeDrawer(); });
    }

    // Close drawer when tapping the overlay background
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) closeDrawer();
      });
    }

    if (applyBtn && drawer) {
      applyBtn.addEventListener('click', function () {
        closeDrawer(function () { applyFilters(); });
      });
    }

    // Mobile group toggles
    var groupToggles = container.querySelectorAll('[data-eb-mobile-group-toggle]');
    groupToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var group = toggle.closest('.eb-filters__mobile-group');
        if (group) {
          group.classList.toggle('is-open');
        }
      });
    });

    // Close drawer on backdrop click
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) {
          drawer.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }
  }

  /* --- Build Filter URL --- */
  function buildFilterUrl() {
    var params = [];

    // Sort
    if (sortSelect && sortSelect.value) {
      params.push('sort_by=' + encodeURIComponent(sortSelect.value));
    }

    // Checkbox filters
    var checkboxes = container.querySelectorAll('[data-eb-filter-value]:checked');
    checkboxes.forEach(function (cb) {
      params.push(encodeURIComponent(cb.name) + '=' + encodeURIComponent(cb.value));
    });

    // Price range — pass dollar values directly (Shopify handles conversion)
    var priceSlider = container.querySelector('[data-eb-price-slider]');
    if (priceSlider) {
      var priceMin = priceSlider.querySelector('[data-eb-price-min]');
      var priceMax = priceSlider.querySelector('[data-eb-price-max]');
      var rangeMin = parseFloat(priceSlider.dataset.rangeMin) || 0;
      var rangeMax = parseFloat(priceSlider.dataset.rangeMax) || 0;

      if (priceMin && priceMin.value && parseFloat(priceMin.value) > rangeMin) {
        params.push(encodeURIComponent(priceMin.name) + '=' + encodeURIComponent(priceMin.value));
      }
      if (priceMax && priceMax.value && parseFloat(priceMax.value) < rangeMax) {
        params.push(encodeURIComponent(priceMax.name) + '=' + encodeURIComponent(priceMax.value));
      }
    }

    return COLLECTION_URL + (params.length > 0 ? '?' + params.join('&') : '');
  }

  /* --- Apply Filters (navigate to filtered URL) --- */
  function applyFilters() {
    var url = buildFilterUrl();
    window.location.href = url;
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
